module.exports = __webpack_public_path__ + "img/testimonial-ruta.e23d73b7.png";